// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Balance.css — responsive overrides for src/pages/Balance.jsx
 * Loads after index.css (via import in Balance.jsx) so wins at equal specificity.
 * Breakpoints: mobile <=576px, tablet 577-991px, laptop 992-1280px, desktop >=1281px.
 * Desktop behaviour is UNCHANGED — all rules are inside max-width media queries.
 */

/* ─── Tablet (≤991px): two-column grid → single column ───────────────────── */
@media (max-width: 991px) {
  .balance-page .two-column-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  /* Stats grid: 2 columns on tablet (already partially handled inline,
     make sure it stays at 2 rather than trying to fit 4) */
  .balance-page .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ─── Mobile (≤576px) ─────────────────────────────────────────────────────── */
@media (max-width: 576px) {
  /* Page wrapper — ensure no horizontal scroll */
  .balance-page {
    min-width: 0;
    overflow-x: hidden;
  }

  /* Page header — stack title + refresh button */
  .balance-page .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    margin-bottom: 1rem;
  }

  .balance-page .page-header h1 {
    font-size: 1.25rem;
  }

  /* Refresh button — full-width, 44px min height */
  .balance-page .refresh-btn {
    width: 100%;
    justify-content: center;
    min-height: 44px;
    padding: 0.625rem 1rem;
  }

  /* Test notice — allow text to wrap */
  .balance-page .test-notice {
    flex-wrap: wrap;
    font-size: 0.8rem;
    padding: 0.75rem;
  }

  /* Stats grid — single column on mobile */
  .balance-page .stats-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
    margin-bottom: 1rem;
  }

  /* Stat cards — comfortable tap size */
  .balance-page .stat-card {
    padding: 1rem;
    min-height: 44px;
  }

  .balance-page .stat-value {
    font-size: 1.25rem;
  }

  /* Section cards — reduce inner padding on mobile */
  .balance-page .section-card {
    border-radius: 10px;
  }

  .balance-page .section-body {
    padding: 0.875rem 1rem;
  }

  .balance-page .section-header {
    padding: 0.875rem 1rem;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  /* "Request refund" button — 44px tap target, full-width on small screens */
  .balance-page .request-refund-btn {
    min-height: 44px;
    padding: 0.625rem 1rem;
    width: 100%;
    justify-content: center;
    font-size: 0.875rem;
  }

  /* Two-column grid — already set to 1fr above, gap tighten */
  .balance-page .two-column-grid {
    gap: 0.75rem;
  }

  /* ── Overpaid rows: reflow to stacked card layout ── */
  .balance-page .overpaid-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 0.875rem 1rem;
    /* Remove the negative margin trick — on mobile use padding on parent */
    margin: 0;
  }

  .balance-page .overpaid-info {
    width: 100%;
  }

  .balance-page .overpaid-amounts {
    text-align: left;
    display: flex;
    gap: 1rem;
    width: 100%;
    flex-wrap: wrap;
  }

  .balance-page .overpaid-original,
  .balance-page .overpaid-paid {
    display: inline;
  }

  .balance-page .overpaid-excess {
    min-width: unset;
    text-align: left;
    font-size: 0.85rem;
  }

  /* ── Transaction rows: reflow ── */
  .balance-page .transaction-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.4rem;
    padding: 0.875rem 1rem;
    margin: 0;
    min-height: 44px;
  }

  .balance-page .tx-info {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .balance-page .tx-currency {
    display: inline;
  }

  .balance-page .tx-date {
    display: inline;
  }

  .balance-page .tx-details {
    text-align: left;
    display: flex;
    gap: 0.75rem;
    align-items: baseline;
    width: 100%;
  }

  .balance-page .tx-amount {
    display: inline;
    font-size: 0.9rem;
  }

  .balance-page .tx-usd {
    display: inline;
  }

  .balance-page .tx-status {
    min-width: unset;
    text-align: left;
    font-size: 0.7rem;
  }

  /* ── Refund rows: reflow ── */
  .balance-page .refund-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.4rem;
    padding: 0.875rem 1rem;
    margin: 0;
  }

  .balance-page .refund-main {
    width: 100%;
  }

  .balance-page .refund-meta {
    text-align: left;
    flex-direction: row;
    gap: 1rem;
    width: 100%;
    flex-wrap: wrap;
  }

  .balance-page .refund-badge {
    min-width: unset;
    align-self: flex-start;
  }

  /* Section footer */
  .balance-page .section-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
    padding: 0.75rem 1rem;
  }

  /* ── Refund modal → bottom sheet on mobile ── */
  .balance-page .refund-modal-overlay {
    align-items: center;
    padding: 0;
  }

  .balance-page .refund-modal {
    width: 100%;
    max-width: 90%;
    border-radius: 16px 16px;
    /* Slide up animation */
    animation: balance-sheet-up 0.25s ease-out;
    /* Allow internal scroll if content is tall */
    max-height: 90dvh;
    max-height: 90vh; /* fallback */
    overflow-y: auto;
    /* Account for notch/home indicator */
    padding-bottom: env(safe-area-inset-bottom, 0px);
    align-self: center;
  }
  .balance-page .bal-recon--info{
    display: inline-grid;
  }
  .bal-card__head{padding:20px 10px !important;}

  @keyframes balance-sheet-up {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  /* Modal close button — 44px tap target */
  .balance-page .refund-modal-close {
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Form fields — full-width inputs */
  .balance-page .refund-form {
    padding: 1rem;
  }

  .balance-page .refund-field input {
    width: 100%;
    box-sizing: border-box;
    min-height: 44px;
    font-size: 1rem; /* prevent iOS auto-zoom */
  }

  /* Form action buttons — stack vertically, full width */
  .balance-page .refund-form-actions {
    flex-direction: column-reverse;
    gap: 0.5rem;
  }

  .balance-page .refund-cancel-btn,
  .balance-page .refund-submit-btn {
    width: 100%;
    min-height: 44px;
    justify-content: center;
    font-size: 0.9rem;
  }

  /* Overpaid list — reset negative margins that rely on fixed padding */
  .balance-page .overpaid-list,
  .balance-page .transactions-list,
  .balance-page .refund-list {
    margin: 0 -1rem; /* pull to edges of section-body */
  }

  .balance-page .overpaid-row,
  .balance-page .transaction-row,
  .balance-page .refund-row {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/Balance.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF,+EAA+E;AAC/E;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;2DACyD;EACzD;IACE,qCAAqC;EACvC;AACF;;AAEA,gFAAgF;AAChF;EACE,+CAA+C;EAC/C;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA,+CAA+C;EAC/C;IACE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,iDAAiD;EACjD;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA,qCAAqC;EACrC;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,yCAAyC;EACzC;IACE,0BAA0B;IAC1B,YAAY;IACZ,mBAAmB;EACrB;;EAEA,sCAAsC;EACtC;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,mDAAmD;EACnD;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,WAAW;EACb;;EAEA,2EAA2E;EAC3E;IACE,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,4DAA4D;EAC5D;IACE,YAAY;EACd;;EAEA,uDAAuD;EACvD;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,uEAAuE;IACvE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,mCAAmC;EACnC;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,8BAA8B;EAC9B;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA,mBAAmB;EACnB;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,qBAAqB;EACvB;;EAEA,gDAAgD;EAChD;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,cAAc;IACd,wBAAwB;IACxB,uBAAuB;IACvB,0CAA0C;IAC1C,6CAA6C;IAC7C,iBAAiB;IACjB,gBAAgB,EAAE,aAAa;IAC/B,gBAAgB;IAChB,qCAAqC;IACrC,gDAAgD;IAChD,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA,gBAAgB,4BAA4B,CAAC;;EAE7C;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,wBAAwB;IAC1B;EACF;;EAEA,yCAAyC;EACzC;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,oCAAoC;EACpC;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,eAAe,EAAE,0BAA0B;EAC7C;;EAEA,uDAAuD;EACvD;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA,sEAAsE;EACtE;;;IAGE,eAAe,EAAE,kCAAkC;EACrD;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":["/*\n * Balance.css — responsive overrides for src/pages/Balance.jsx\n * Loads after index.css (via import in Balance.jsx) so wins at equal specificity.\n * Breakpoints: mobile <=576px, tablet 577-991px, laptop 992-1280px, desktop >=1281px.\n * Desktop behaviour is UNCHANGED — all rules are inside max-width media queries.\n */\n\n/* ─── Tablet (≤991px): two-column grid → single column ───────────────────── */\n@media (max-width: 991px) {\n  .balance-page .two-column-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  /* Stats grid: 2 columns on tablet (already partially handled inline,\n     make sure it stays at 2 rather than trying to fit 4) */\n  .balance-page .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* ─── Mobile (≤576px) ─────────────────────────────────────────────────────── */\n@media (max-width: 576px) {\n  /* Page wrapper — ensure no horizontal scroll */\n  .balance-page {\n    min-width: 0;\n    overflow-x: hidden;\n  }\n\n  /* Page header — stack title + refresh button */\n  .balance-page .page-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n  }\n\n  .balance-page .page-header h1 {\n    font-size: 1.25rem;\n  }\n\n  /* Refresh button — full-width, 44px min height */\n  .balance-page .refresh-btn {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n    padding: 0.625rem 1rem;\n  }\n\n  /* Test notice — allow text to wrap */\n  .balance-page .test-notice {\n    flex-wrap: wrap;\n    font-size: 0.8rem;\n    padding: 0.75rem;\n  }\n\n  /* Stats grid — single column on mobile */\n  .balance-page .stats-grid {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n  }\n\n  /* Stat cards — comfortable tap size */\n  .balance-page .stat-card {\n    padding: 1rem;\n    min-height: 44px;\n  }\n\n  .balance-page .stat-value {\n    font-size: 1.25rem;\n  }\n\n  /* Section cards — reduce inner padding on mobile */\n  .balance-page .section-card {\n    border-radius: 10px;\n  }\n\n  .balance-page .section-body {\n    padding: 0.875rem 1rem;\n  }\n\n  .balance-page .section-header {\n    padding: 0.875rem 1rem;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  /* \"Request refund\" button — 44px tap target, full-width on small screens */\n  .balance-page .request-refund-btn {\n    min-height: 44px;\n    padding: 0.625rem 1rem;\n    width: 100%;\n    justify-content: center;\n    font-size: 0.875rem;\n  }\n\n  /* Two-column grid — already set to 1fr above, gap tighten */\n  .balance-page .two-column-grid {\n    gap: 0.75rem;\n  }\n\n  /* ── Overpaid rows: reflow to stacked card layout ── */\n  .balance-page .overpaid-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n    padding: 0.875rem 1rem;\n    /* Remove the negative margin trick — on mobile use padding on parent */\n    margin: 0;\n  }\n\n  .balance-page .overpaid-info {\n    width: 100%;\n  }\n\n  .balance-page .overpaid-amounts {\n    text-align: left;\n    display: flex;\n    gap: 1rem;\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .balance-page .overpaid-original,\n  .balance-page .overpaid-paid {\n    display: inline;\n  }\n\n  .balance-page .overpaid-excess {\n    min-width: unset;\n    text-align: left;\n    font-size: 0.85rem;\n  }\n\n  /* ── Transaction rows: reflow ── */\n  .balance-page .transaction-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.4rem;\n    padding: 0.875rem 1rem;\n    margin: 0;\n    min-height: 44px;\n  }\n\n  .balance-page .tx-info {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .balance-page .tx-currency {\n    display: inline;\n  }\n\n  .balance-page .tx-date {\n    display: inline;\n  }\n\n  .balance-page .tx-details {\n    text-align: left;\n    display: flex;\n    gap: 0.75rem;\n    align-items: baseline;\n    width: 100%;\n  }\n\n  .balance-page .tx-amount {\n    display: inline;\n    font-size: 0.9rem;\n  }\n\n  .balance-page .tx-usd {\n    display: inline;\n  }\n\n  .balance-page .tx-status {\n    min-width: unset;\n    text-align: left;\n    font-size: 0.7rem;\n  }\n\n  /* ── Refund rows: reflow ── */\n  .balance-page .refund-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.4rem;\n    padding: 0.875rem 1rem;\n    margin: 0;\n  }\n\n  .balance-page .refund-main {\n    width: 100%;\n  }\n\n  .balance-page .refund-meta {\n    text-align: left;\n    flex-direction: row;\n    gap: 1rem;\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .balance-page .refund-badge {\n    min-width: unset;\n    align-self: flex-start;\n  }\n\n  /* Section footer */\n  .balance-page .section-footer {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.25rem;\n    padding: 0.75rem 1rem;\n  }\n\n  /* ── Refund modal → bottom sheet on mobile ── */\n  .balance-page .refund-modal-overlay {\n    align-items: center;\n    padding: 0;\n  }\n\n  .balance-page .refund-modal {\n    width: 100%;\n    max-width: 90%;\n    border-radius: 16px 16px;\n    /* Slide up animation */\n    animation: balance-sheet-up 0.25s ease-out;\n    /* Allow internal scroll if content is tall */\n    max-height: 90dvh;\n    max-height: 90vh; /* fallback */\n    overflow-y: auto;\n    /* Account for notch/home indicator */\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n    align-self: center;\n  }\n  .balance-page .bal-recon--info{\n    display: inline-grid;\n  }\n  .bal-card__head{padding:20px 10px !important;}\n\n  @keyframes balance-sheet-up {\n    from {\n      transform: translateY(100%);\n    }\n    to {\n      transform: translateY(0);\n    }\n  }\n\n  /* Modal close button — 44px tap target */\n  .balance-page .refund-modal-close {\n    min-width: 44px;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* Form fields — full-width inputs */\n  .balance-page .refund-form {\n    padding: 1rem;\n  }\n\n  .balance-page .refund-field input {\n    width: 100%;\n    box-sizing: border-box;\n    min-height: 44px;\n    font-size: 1rem; /* prevent iOS auto-zoom */\n  }\n\n  /* Form action buttons — stack vertically, full width */\n  .balance-page .refund-form-actions {\n    flex-direction: column-reverse;\n    gap: 0.5rem;\n  }\n\n  .balance-page .refund-cancel-btn,\n  .balance-page .refund-submit-btn {\n    width: 100%;\n    min-height: 44px;\n    justify-content: center;\n    font-size: 0.9rem;\n  }\n\n  /* Overpaid list — reset negative margins that rely on fixed padding */\n  .balance-page .overpaid-list,\n  .balance-page .transactions-list,\n  .balance-page .refund-list {\n    margin: 0 -1rem; /* pull to edges of section-body */\n  }\n\n  .balance-page .overpaid-row,\n  .balance-page .transaction-row,\n  .balance-page .refund-row {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
